export default {
  scientificWork: {},
  scientificWorks: [],
}
